import setDependencies from './set-dependencies';

export default {
  setDependencies,
};
